import { Injectable } from '@angular/core';
import { FirestoreService } from '../firebase/firestore.service';
import { from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ActionLoadSearchRecords } from './store/search.actions';
import { SearchRecord } from './store/search.model';

@Injectable({ providedIn: 'root' })
export class SearchDataService {

    constructor(private firestoreService: FirestoreService) {}

    upsertSearch(searchRecord: SearchRecord) {
        return from(this.firestoreService.setDoc(this.firestoreService.doc('searches', searchRecord.id), searchRecord, { merge: true }));
    }

    fetchSearches(createdBy: string) {
        const millisInAWeek = 7 * 24 * 60 * 60 * 1000;
        const previousWeek = Date.now() - millisInAWeek;
        const q = this.firestoreService.query(
            this.firestoreService.collection('searches'),
            this.firestoreService.where('createdBy', '==', createdBy),
            this.firestoreService.where('updatedAt', '>', previousWeek),
            this.firestoreService.orderBy('updatedAt', 'desc'),
            this.firestoreService.limit(25)
        );
        return from(this.firestoreService.getDocs(q)).pipe(
            map(snapshot => snapshot.docs.map(documentSnapshot => documentSnapshot.data() as SearchRecord)),
            switchMap(searchRecords => of(new ActionLoadSearchRecords({ searchRecords })))
        );
    }
}
